<template>
  <div class="input-group input-group-sm filter-field-number-group">
    <select
      :value="filterOperator"
      class="form-select form-select-sm filter-op-select"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value=">">{{ $t('Greater than') }}</option>
      <option value="<">{{ $t('Less than') }}</option>
      <option value=">=">{{ $t('Greater than or equal to') }}</option>
      <option value="<=">{{ $t('Less than or equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <input
      type="number"
      :value="displayValue"
      :id="computedFieldId"
      class="form-control form-control-sm field-number"
      :class="{
        'currency-field': field.currency,
      }"
      :placeholder="placeholder"
      :readonly="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      :step="field.currency ? '0.01' : 'any'"
      @input="onFilterValueChange($event.target.value)"
      @blur="onFilterValueChange($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "FilterFieldNumber",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return null;
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-number-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      const numValue = newValue === '' || newValue === null ? null : parseFloat(newValue);
      const finalValue = isNaN(numValue) ? null : numValue;
      this.$emit("input", finalValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
  align-items: stretch;
}

.filter-op-select {
  flex: 0 0 auto;
  width: auto;
  min-width: 5.75rem;
  max-width: 9.5rem;
}
</style>

